import { render, staticRenderFns } from "./CheckboxWidget.vue?vue&type=template&id=b1f8a41a&"
import script from "./CheckboxWidget.vue?vue&type=script&lang=ts&"
export * from "./CheckboxWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxWidget.vue?vue&type=style&index=0&id=b1f8a41a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports